<div class="user-avatar" *ngIf="user" [attr.user-id]="user.id">
    <div class="initials" *ngIf="!user.image; else image_state">{{ initials }}</div>
</div>
<ng-template #image_state>
    <img [src]="user.image | safe: 'resource'" />
</ng-template>
